// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { displayPercent } from './Number';

const ProgressContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 5px;
`;

const Progress = styled.div`
  width: ${props => props.percentage * 100}%;
  max-width: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  border-radius: 5px;
  white-space: nowrap;
  ${props => (props.percentage > 0.05 ? 'color: white;' : '')}
`;

type Props = {
  minValue: number,
  maxValue: number,
  value: number,
  theme: any,
};

function ProgressBar(props: Props) {
  const percentage = ((props.value || 0) - props.minValue) / (props.maxValue - props.minValue);
  const text = displayPercent(percentage);
  return (
    <ProgressContainer>
      <Progress percentage={percentage}>
        {text}
      </Progress>
    </ProgressContainer>
  );
}

ProgressBar.defaultProps = {
  minValue: 0,
  maxValue: 100,
};

export default withTheme(ProgressBar);



// WEBPACK FOOTER //
// ./src/common/components/ProgressBar.js